var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('div',[_vm._v("您访问的页面不存在~")]),_c('p',[_vm._v("点击返回 "),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("企业福利助手首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }